import type { ReactNode } from "react";
import { RecordPanel } from "./RecordFrame";

/** Key/value details, plus anything the page adds under them (a firm bio, a source line). */
export function RailDetails({ rows, children }: { rows: [string, ReactNode][]; children?: ReactNode }) {
  return (
    <RecordPanel title="Details">
      <dl className="m-0 grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-1 text-[12.5px]">
        {rows.map(([k, v]) => (
          <div key={k} className="contents">
            <dt className="text-muted-foreground">{k}</dt>
            <dd className="m-0 text-right [overflow-wrap:anywhere]">{typeof v === "string" ? <span className="line-clamp-2" title={v}>{v}</span> : v}</dd>
          </div>
        ))}
      </dl>
      {children}
    </RecordPanel>
  );
}
